const reactDatePickerStyleOverrides = {
    '.react-datepicker': {
        fontSize: 'sm',
        fontWeight: 'normal',
        padding: 2,
        background: 'white',
        borderBottomWidth: '2px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'accent',
        borderRightWidth: '2px',
        borderRightStyle: 'solid',
        borderRightColor: 'accent',
        borderRadius: '8px',
    },
    '.react-datepicker__day--today': {
        background: 'blue.100',
        color: 'black',
        fontWeight: 'bold',
    },
    '.react-datepicker__week, .react-datepicker__day-names': {
        display: 'flex',
        justifyContent: 'space-between',
    },
    '.react-datepicker__header': {
        userSelect: 'none',
        background: 'white',
        border: 'none',
        padding: '0',
        '.react-datepicker__current-month': {
            fontWeight: 'semibold',
            fontSize: 'xl',
        },
    },
    '.react-datepicker__day': {
        borderRadius: '50%',
        ':hover': {
            borderRadius: '50%',
        },
        cursor: 'pointer',
    },
    '.react-datepicker__day, .react-datepicker__day-name': {
        flex: 1,
        paddingY: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: {base: 0.5, mobileXL: 1},
    },
    '.react-datepicker__day--disabled': {
        color: 'gray.600',
        cursor: 'not-allowed',
    },
    '.react-datepicker__aria-live': {
        display: 'none',
    },
    '.react-datepicker__day--highlighted, .react-datepicker__day--selected, .react-datepicker__day--range-end, .react-datepicker__day--range-start, .react-datepicker__day--in-range, .react-datepicker__day--in-selecting-range': {
        background: 'secondary.default',
        color: 'white',
        fontWeight: 'bold',
        maxWidth: '2.5rem',
    },
};

export default reactDatePickerStyleOverrides;
